import { createAsyncThunk } from "@reduxjs/toolkit";

import { EVENTS } from "../../utils/constants/APIURL.constants";

import AppService from "../../services/AppService";
import { getQueryUrl } from "../../helpers/authhelper";

export const getCincs = createAsyncThunk(
  "admin/cincs",
  async (params, { rejectWithValue }) => {
    const url = EVENTS.EVENT + "?" + getQueryUrl(params);
    try {
      const data = await AppService.getCall(url);
      return { data: data.result, totalRowCount: data.count };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const deleteCincById = createAsyncThunk(
  "admin/deleteCinctById",
  async (id, { rejectWithValue }) => {
    const url = EVENTS.EVENT + id + "/";
    try {
      const data = await AppService.deleteCall(url);
      return { ...data, id };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getCinctById = createAsyncThunk(
  "admin/getCinctById",
  async (id, { rejectWithValue }) => {
    const url = EVENTS.EVENT + id + "/";
    try {
      const data = await AppService.getCall(url);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const updateCinc = createAsyncThunk(
  "admin/updateCinc",
  async ({ values, id }, { rejectWithValue }) => {
    const url = EVENTS.EVENT + id + "/";
    try {
      const data = await AppService.putCall(values, url);
      if (data?.is_error) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getEventCategories = createAsyncThunk(
  "admin/getEventCategories",
  async (obj, { rejectWithValue }) => {
    const url = EVENTS.CATEGORIES;
    try {
      const data = await AppService.getCall(url, "token");

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
